import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const Root = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  display: flex;
  flex-direction: column;
`;

const Title = styled(T.Body3)`
  margin-block-end: 8px;
`;

const Description = styled(T.Body3)``;

const Disclaimer = () => {
  return (
    <Root>
      <Title>
        <FormattedMessage id="insights.disclaimer.header" />
      </Title>
      <Description>
        <FormattedMessage id="insights.disclaimer.text" />
      </Description>
    </Root>
  );
};

export default Disclaimer;
